export * from './StrapiTradeBenefitsWidget'
